<template>
    <v-simple-table>
        <template #default>
            <tbody>
                <tr v-for="requiredField in requiredFields(mobility)" :key="requiredField">
                    <td>{{ title(requiredField) }}</td>
                    <td>
                        {{ parse(requiredField) }}
                    </td>
                </tr>
            </tbody>
        </template>
    </v-simple-table>
</template>

<script>
import numeral from 'numeral';

const numericFields = {
    total_score: '0.0',
    routine_1_e_score: '0.0',
    routine_2_e_score: '0.0',
    routine_2_d_score: '0.0',
    d_score: '0.0',
    total_w_tof: '0.000',
};

export default {
    name: 'MobilityTable',

    props: {
        mobility: {
            type: Object,
            required: true,
        },
    },

    data: () => ({}),

    methods: {
        requiredFields(mobility) {
            const consideredFields = [
                'event',
                'gender',
                'level_from',
                'level_to',
                'total_score',
                'routine_1_e_score',
                'routine_2_e_score',
                'routine_2_d_score',
                'd_score',
                'total_w_tof',
            ];

            return consideredFields.filter(field => mobility[field] !== null);
        },

        parse(field) {
            if (field === 'event') {
                return { tra: 'Trampoline', dmt: 'Double-Mini', tum: 'Tumbling' }[this.mobility[field]];
            }

            if (Object.keys(numericFields).includes(field)) {
                return numeral(this.mobility[field]).format(numericFields[field]);
            }

            return this.mobility[field];
        },

        title(field) {
            return {
                year_from: 'Year From',
                year_to: 'Year To',
                event: 'Event',
                gender: 'Gender',
                level_from: 'Level From',
                level_to: 'Level To',
                total_score: 'Total Score',
                routine_1_e_score: 'Routine 1 Execution',
                routine_2_e_score: 'Routine 2 Execution',
                routine_2_d_score: 'Routine 2 Difficulty',
                d_score: 'Difficulty Score',
                total_w_tof: 'Total Score w/ Time of Flight',
                notes: 'Notes',
            }[field];
        },
    },
};
</script>
